(function() {
    'use strict';
    angular
        .module('publicGatewayApp')
        .factory('PublicProfile', PublicProfile);

    PublicProfile.$inject = ['$resource'];

    function PublicProfile ($resource) {
        var resourceUrl =  'api/public-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
